(() => {
  const ROOT_SEL = "#simple-bundles-io-options";
  const BUNDLE_PATH = "/products/hydropot-bundle";

  const COLOR_MAP = {
    white: "#ffffff",
    cream: "#f3ead7",
    grey: "#8a8f98",
    gray: "#8a8f98",
    black: "#111111",
  };

  const normalize = (s) => (s || "").trim().toLowerCase();
  const getColor = (value) => COLOR_MAP[normalize(value)] || null;

// ADDING TO MANUALLY REMOVE SWATCHES WHEN POTS ARE OUT OF STOCK
function isUSMarket() {
  const country =
    window.Shopify?.country ||
    document.documentElement.getAttribute("data-country") ||
    "";
  return String(country).toUpperCase() === "US";
}

function isCanadaMarket() {
  const country =
    window.Shopify?.country ||
    document.documentElement.getAttribute("data-country") ||
    "";
  return String(country).toUpperCase() === "CA";
}

// END OF REMOVE SWATCH CODE

  function buildSwatchesForSelect(selectEl) {
    if (selectEl.dataset.sbSwatches === "1") return;

// ADDING TO MANUALLY REMOVE SWATCHES WHEN POTS ARE OUT OF STOCK

const labelText = normalize(labelTextForSelect(selectEl));

const isFourInchSelect =
  labelText.includes("4-inch") ||
  labelText.includes("4 inch") ||
  labelText === "4";

const isFiveFiveInchSelect =
  labelText.includes("5.5-inch") ||
  labelText.includes("5.5 inch") ||
  labelText.includes("5.5");

let hiddenColors = [];

// No hidden swatches while pre-orders are active
hiddenColors = [];

if (hiddenColors.length) {
  Array.from(selectEl.options).forEach((o) => {
    if (hiddenColors.includes(normalize(o.textContent))) {
      o.disabled = true;
    }
  });

  const selectedOption =
    selectEl.options[selectEl.selectedIndex];

  const selectedColor =
    selectedOption
      ? normalize(selectedOption.textContent)
      : "";

  if (hiddenColors.includes(selectedColor)) {
    const firstAvailable = Array.from(selectEl.options).find(
      (o) => o.value && !o.disabled
    );

    if (firstAvailable) {
      selectEl.value = firstAvailable.value;

      selectEl.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }
  }
}

const options = Array.from(selectEl.options).filter((o) => o.value && !o.disabled);

    // END OF REMOVE SWATCH CODE

    if (options.length < 1) return;

    const grid = document.createElement("div");
    grid.className = "sb-swatch-grid";

    const refresh = () => {
      const current = selectEl.value;
      grid.querySelectorAll(".sb-swatch").forEach((b) => b.classList.remove("is-selected"));
      const active = grid.querySelector(`[data-value="${CSS.escape(current)}"]`);
      if (active) active.classList.add("is-selected");
    };

    options.forEach((opt) => {
      const label = opt.textContent.trim();
      const color = getColor(label);

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "sb-swatch";
      btn.style.background = color || "#ddd";
      btn.setAttribute("aria-label", label);
      btn.dataset.value = opt.value;

      btn.addEventListener("click", () => {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
        refresh();
      });

      grid.appendChild(btn);
    });

    selectEl.classList.add("sb-hidden-select");
    selectEl.parentNode.insertBefore(grid, selectEl.nextSibling);

    selectEl.dataset.sbSwatches = "1";
    selectEl.addEventListener("change", refresh);
    refresh();
  }

  function labelTextForSelect(selectEl) {
    const prev = selectEl.previousElementSibling;
    if (prev && prev.tagName === "LABEL") return (prev.textContent || "").trim();
    return (selectEl.getAttribute("aria-label") || "").trim();
  }

  function ensureGroupHeaders(root) {
    // Always remove old generated elements
    root.querySelectorAll(".sb-generated-header, .sb-generated-divider").forEach((n) => n.remove());

    const selects = Array.from(root.querySelectorAll("select"));
    if (!selects.length) return;

    const four = [];
    const fivefive = [];

    selects.forEach((sel) => {
      const t = normalize(labelTextForSelect(sel));

      if (t.includes("5.5-inch") || t.includes("5.5 inch") || t.includes("5.5")) {
        fivefive.push(sel);
      } else if (t.includes("4-inch") || t.includes("4 inch") || t.includes("4")) {
        four.push(sel);
      }
    });

    // Only show divider on the bundle product
    const showDivider = window.location.pathname.includes(BUNDLE_PATH);

    const insertHeaderBefore = (selectEl, text, withDivider = false) => {
      const frag = document.createDocumentFragment();

      if (withDivider) {
        const d = document.createElement("div");
        d.className = "sb-generated-divider";
        frag.appendChild(d);
      }

      const h = document.createElement("div");
      h.className = "sb-generated-header";
      h.textContent = text;
      frag.appendChild(h);

      selectEl.parentNode.insertBefore(frag, selectEl);
    };

    if (four.length) {
      insertHeaderBefore(four[0], `4-inch planter color × ${four.length}`, false);
    }

    if (fivefive.length) {
      insertHeaderBefore(
        fivefive[0],
        `5.5-inch planter color × ${fivefive.length}`,
        showDivider // ✅ divider only on bundle page
      );
    }
  }


function init() {
  const root = document.querySelector(ROOT_SEL);
  if (!root) return;

  root.querySelectorAll("select").forEach(buildSwatchesForSelect);
  ensureGroupHeaders(root);
}


  document.addEventListener("DOMContentLoaded", () => {
    init();

    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    const obs = new MutationObserver(() => init());
    obs.observe(root, { childList: true, subtree: true });
  });
})();